import { Activity } from "../entities/interfaces/actviity";
import {
  PeriodicMetric,
  StaffWithPerformance,
} from "../entities/interfaces/analytics";
import Api, { ApiResponse } from "../utils/axios";

export const periodicMetric = async (
  from: string,
  to: string
): Promise<ApiResponse<PeriodicMetric>> => {
  return await Api.get(
    `/analytics/periodic?${new URLSearchParams({ from, to })}`
  );
};

export const staffPerformance = async (
  from: string,
  to: string
): Promise<ApiResponse<StaffWithPerformance[]>> => {
  return await Api.get(
    `/analytics/staffPerformance?${new URLSearchParams({ from, to })}`
  );
};

// export const create = async (
//   createServiceDto: CreateServiceDto
// ): Promise<ApiResponse<Service[]>> => {
//   return await Api.post("/services", createServiceDto);
// };

// export const update = async (
//   id: string,
//   updateServiceDto: UpdateServiceDto
// ): Promise<ApiResponse<Service[]>> => {
//   return await Api.patch(`/services/${id}`, updateServiceDto);
// };

const AnalyticsService = { periodicMetric, staffPerformance };
export default AnalyticsService;
